import React from 'react';
import PropTypes from 'prop-types';

import classNames from 'classnames';
import pluralize from 'pluralize';

import Tooltip from 'components/tooltip';
import { Button } from 'react-bootstrap-5';

export default function SelectionDetails({
  forTable,
  label,
  onlySelectedCount,
  responsive = true,
  selectedCount,
  stickLeft,
  totalCount,
  onClearSelection,
  onSelectAll,
}) {
  // TODO: This messaging could be clearer about selections that are not visible, e.g. if you select
  //       one result, and change filters so that item is exlucded and there is only one result,
  //       this will read "All 1 item is selected".
  let statement = `${pluralize(label, selectedCount, true)} ${pluralize(
    'is',
    selectedCount
  )} selected.`;

  let control;
  if (selectedCount === totalCount && totalCount > 0) {
    statement = `All ${statement}`;
    control = (
      <Button size="sm" variant="outline" onClick={onClearSelection}>
        Clear Selection
      </Button>
    );
  } else if (selectedCount > 0) {
    if (onlySelectedCount) {
      control = (
        <Button size="sm" variant="outline" onClick={onClearSelection}>
          Clear Selection
        </Button>
      );
    } else {
      let controlText = `Select all ${pluralize(label, totalCount, true)}`;
      if (forTable) {
        controlText = `${controlText} that match this search.`;
      } else {
        controlText = `${controlText}.`;
      }

      control = (
        <Button size="sm" variant="ghost" onClick={onSelectAll}>
          {controlText}
        </Button>
      );

      if (forTable) {
        control = (
          <Tooltip
            content="
              This will override any previous selections that do not match this search.
              You can add to your previous selections by selecting individual rows instead.
            "
            overlayClassName="tooltip-popover-dark"
            placement="bottom"
          >
            {control}
          </Tooltip>
        );
      }
    }
  } else {
    return null;
  }

  const content = (
    <React.Fragment>
      {statement} {control}
    </React.Fragment>
  );

  if (forTable) {
    return (
      <tr className={classNames({ 'd-none d-md-table-row': responsive })}>
        <td
          className={classNames('text-bg-secondary text-center align-middle', {
            'sticky-cell': stickLeft,
          })}
          colSpan="100%"
        >
          {content}
        </td>
      </tr>
    );
  } else {
    return (
      <div className="p-2 text-bg-secondary border-bottom text-center align-middle">
        {content}
      </div>
    );
  }
}

SelectionDetails.propTypes = {
  forTable: PropTypes.bool,
  label: PropTypes.string.isRequired,
  onlySelectedCount: PropTypes.bool,
  responsive: PropTypes.bool,
  selectedCount: PropTypes.number.isRequired,
  stickLeft: PropTypes.bool,
  totalCount: PropTypes.number,
  onClearSelection: PropTypes.func,
  onSelectAll: PropTypes.func,
};
